import React from "react";
import { Typography } from "@mui/material";
import { ComponentExample } from "components/examples";

const ControlledBuilders = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Controlled Builders
    </Typography>
    <ComponentExample
      name="List filters"
      description="A controlled FormBuilder can be used to render filters for a ListBuilder."
      import={import("examples/Builders/ControlledBuilders/ListFiltersExample")}
      rawImport={import(
        "examples/Builders/ControlledBuilders/ListFiltersExample?raw"
      )}
    />
    <ComponentExample
      name="External data refresh"
      description="The loadParams prop can be used to force a builder component to refresh. This should only be used in situations where it's not possible to trigger the refresh from within the render prop by calling the onRefresh event."
      import={import(
        "examples/Builders/ControlledBuilders/ExternalDataRefreshExample"
      )}
      rawImport={import(
        "examples/Builders/ControlledBuilders/ExternalDataRefreshExample?raw"
      )}
    />
    <ComponentExample
      name="Edit external data"
      description="The initialData prop can be used to supply data to a FormBuilder from an external source. When external data changes need to be reflected immediately the onLoad and loadParams props can be used instead."
      import={import(
        "examples/Builders/ControlledBuilders/EditExternalDataExample"
      )}
      rawImport={import(
        "examples/Builders/ControlledBuilders/EditExternalDataExample?raw"
      )}
    />
  </React.Fragment>
);

export default ControlledBuilders;
